import { useMemo } from 'react';
import {
	useJiraSettingStoreIssueLinkType,
	useJiraSettingStoreTimeTracking,
	useSettingsActions,
} from './context.tsx';

export const useTimeTrackingConfiguration = () => {
	const [timeTrackingConfiguration] = useJiraSettingStoreTimeTracking();

	return [timeTrackingConfiguration] as const;
};

export const useIssueLinkTypes = () => {
	const [issueLinkTypes] = useJiraSettingStoreIssueLinkType();

	return [issueLinkTypes] as const;
};

export const useJiraSettingsActions = () => {
	const [, { setJiraSettings }] = useSettingsActions();

	const actions = useMemo(() => ({ setJiraSettings }), [setJiraSettings]);

	return [null, actions] as const;
};
